const initialState = {
  loading: false,
  positions: null,
  error: null
}

function reducer (state = initialState, action) {
  switch (action.type) {
    case 'SET_POSITIONS_LOADING': {
      return {
        ...initialState,
        loading: true
      }
    }
    case 'SET_POSITIONS': {
      return {
        ...initialState,
        positions: action.positions
      }
    }
    case 'SET_POSITIONS_ERROR': {
      return {
        ...initialState,
        error: action.error
      }
    }
    default: return state
  }
}

export default reducer
